/**
 * @flow
 * @relayHash e6cd5cee04847478a5e26151863e848c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddInvoiceToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type InvoiceComponent_addInvoiceToSessionMutationVariables = {|
  input: AddInvoiceToSessionInput
|};
export type InvoiceComponent_addInvoiceToSessionMutationResponse = {|
  +addInvoiceToSession: ?{|
    +invoice: ?{|
      +id: string
    |}
  |}
|};
export type InvoiceComponent_addInvoiceToSessionMutation = {|
  variables: InvoiceComponent_addInvoiceToSessionMutationVariables,
  response: InvoiceComponent_addInvoiceToSessionMutationResponse,
|};
*/


/*
mutation InvoiceComponent_addInvoiceToSessionMutation(
  $input: AddInvoiceToSessionInput!
) {
  addInvoiceToSession(input: $input) {
    invoice {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddInvoiceToSessionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addInvoiceToSession",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddInvoiceToSessionInput!"
      }
    ],
    "concreteType": "AddInvoiceToSessionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "invoice",
        "storageKey": null,
        "args": null,
        "concreteType": "Invoice",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "InvoiceComponent_addInvoiceToSessionMutation",
  "id": null,
  "text": "mutation InvoiceComponent_addInvoiceToSessionMutation(\n  $input: AddInvoiceToSessionInput!\n) {\n  addInvoiceToSession(input: $input) {\n    invoice {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "InvoiceComponent_addInvoiceToSessionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "InvoiceComponent_addInvoiceToSessionMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3e88246bce05ed3210cfecc671117c16';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/__generated__/InvoiceComponent_addInvoiceToSessionMutation.graphql.js